// extracted by mini-css-extract-plugin
export default {"root":"QuoteSection__root--omwTy","header":"QuoteSection__header--iYdRQ","subtotal":"QuoteSection__subtotal--B8uab","items":"QuoteSection__items--ZRpbS"};